import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { renderUserAvatar } from "@/lib/avatar";

export default function SavedView() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/saved-messages").then((r) => setItems(r.data)); }, []);
  return (
    <div className="flex-1 flex flex-col overflow-hidden bg-white">
      <div className="h-14 border-b flex items-center px-6 shrink-0"><h1 className="text-lg font-semibold">Saved messages</h1></div>
      <div className="flex-1 overflow-auto p-6 max-w-2xl space-y-2 scroll-thin">
        {items.length === 0 && <div className="text-sm text-zinc-400">Nothing saved yet.</div>}
        {items.map((i) => (
          <div key={i.message?.id} className="p-3 border rounded-lg">
            <div className="text-xs text-zinc-500">Saved {new Date(i.saved_at).toLocaleString()}</div>
            <div className="flex items-center gap-2 mt-1"><img src={renderUserAvatar(i.message?.user)} className="w-6 h-6 rounded-full object-cover" alt=""/><span className="text-sm font-medium">{i.message?.user?.name}</span></div>
            <div className="text-sm mt-1">{i.message?.text}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
